var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#008B44"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7598_9577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7623 8.45312H21.8194C22.1831 8.45312 22.532 8.59761 22.7892 8.85481C23.0464 9.112 23.1908 9.46083 23.1908 9.82455V23.5388C23.1908 23.9026 23.0464 24.2514 22.7892 24.5086C22.532 24.7658 22.1831 24.9103 21.8194 24.9103H10.848C10.4843 24.9103 10.1354 24.7658 9.87824 24.5086C9.62105 24.2514 9.47656 23.9026 9.47656 23.5388V9.82455C9.47656 9.46083 9.62105 9.112 9.87824 8.85481C10.1354 8.59761 10.4843 8.45312 10.848 8.45312H12.9051",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3907 7.08203H14.2765C13.9127 7.08203 13.5639 7.22652 13.3067 7.48371C13.0495 7.74091 12.905 8.08973 12.905 8.45346V9.13917C12.905 9.5029 13.0495 9.85173 13.3067 10.1089C13.5639 10.3661 13.9127 10.5106 14.2765 10.5106H18.3907C18.7545 10.5106 19.1033 10.3661 19.3605 10.1089C19.6177 9.85173 19.7622 9.5029 19.7622 9.13917V8.45346C19.7622 8.08973 19.6177 7.74091 19.3605 7.48371C19.1033 7.22652 18.7545 7.08203 18.3907 7.08203ZM15.3777 13.5415C15.2213 13.5415 15.0713 13.6036 14.9607 13.7142C14.8501 13.8248 14.788 13.9748 14.788 14.1312V15.7865H13.1327C12.9763 15.7865 12.8263 15.8486 12.7157 15.9592C12.6051 16.0698 12.543 16.2198 12.543 16.3762V18.2893C12.543 18.6144 12.8077 18.8791 13.1327 18.8791H14.788V20.5344C14.788 20.8594 15.0527 21.1241 15.3777 21.1241H17.2909C17.4473 21.1241 17.5973 21.062 17.7078 20.9514C17.8184 20.8408 17.8806 20.6908 17.8806 20.5344V18.8763H19.5359C19.6923 18.8763 19.8423 18.8142 19.9529 18.7036C20.0635 18.593 20.1256 18.443 20.1256 18.2866V16.3762C20.1252 16.22 20.0629 16.0704 19.9524 15.9601C19.8418 15.8498 19.692 15.7879 19.5359 15.7879H17.8806V14.1298C17.8802 13.9736 17.8179 13.824 17.7074 13.7137C17.5968 13.6034 17.447 13.5415 17.2909 13.5415H15.3777Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7598_9577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(6.7334 6.39844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.ca1d3ae8d9364ca316b2f4fd6c1f3bac.svg";
export { ForwardRef as ReactComponent };